import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: "/",
  routes: [
    {
      path: "/",
      name: "Landing",
      props: true,
      component: () => import("@/view/pages/Landing.vue"),
    },
    {
      path: "/landing",
      name: "Landing",
      props: true,
      component: () => import("@/view/pages/Landing.vue"),
    },

    {
      path: "/admin",
      name: "admin",
      redirect: "/admin/dashboard",
      component: () => import("@/view/layout/Layout"),
      children: [
        {
          path: "/admin/dashboard",
          name: "Dashboard",
          component: () => import("@/view/pages/dashboard/Dashboard.vue"),
          children: [
            {
              path: "",
              name: "dashboard",
              component: () =>
                import(
                  "@/view/pages/dashboard/welcome-dashboard/dashboard.vue"
                ),
            },
          ],
        },
        {
          path: "/admin/member",
          name: "Member",
          component: () => import("@/view/pages/member/Member.vue"),
          children: [
            {
              path: "",
              name: "member",
              component: () =>
                import("@/view/pages/member/data-member/ListUser.vue"),
            },

            {
              path: "checkin-member",
              name: "checkin-member",
              component: () =>
                import("@/view/pages/member/checkin-member/List.vue"),
            },
            {
              path: "reservation-pt",
              name: "reservation-pt",
              component: () =>
                import("@/view/pages/member/reservation-pt/List.vue"),
            },

            {
              path: "transfer-request",
              name: "transfer-request",
              component: () =>
                import("@/view/pages/member/transfer-request/List.vue"),
            },
            {
              path: "transfer-personal-trainer",
              name: "transfer-personal-trainer",
              component: () =>
                import("@/view/pages/member/transfer-personal-trainer/List.vue"),
            },
            {
              path: "leave-request",
              name: "leave-request",
              component: () =>
                import("@/view/pages/member/leave-request/List.vue"),
            },
            {
              path: "hold-package",
              name: "hold-package",
              component: () =>
                import("@/view/pages/member/hold-package/List.vue"),
            },
            {
              path: "paid-trial-class",
              name: "paid-trial-class",
              component: () =>
                import("@/view/pages/member/paid-trial-class/List.vue"),
            },
          ],
        },
        {
          path: "/admin/package-management",
          name: "package-management",
          component: () =>
            import("@/view/pages/package-management/Management.vue"),
          children: [
            {
              path: "package",
              name: "package",
              component: () =>
                import("@/view/pages/package-management/package/List.vue"),
            },
            {
              path: "promo",
              name: "promo",
              component: () =>
                import("@/view/pages/package-management/promo/List.vue"),
            },
            {
              path: "class-type",
              name: "Kelas",
              component: () =>
                import("@/view/pages/package-management/class-type/List.vue"),
            },
            {
              path: "class-instructor",
              name: "Instruktur Kelas",
              component: () =>
                import(
                  "@/view/pages/package-management/class-type/class-instructor/List.vue"
                ),
            },
            {
              path: "class-schedule",
              name: "Kelas",
              component: () =>
                import(
                  "@/view/pages/package-management/class-type/class-schedule/List.vue"
                ),
            },
          ],
        },
        {
          path: "/admin/sales-management",
          name: "sales-management",
          component: () =>
            import("@/view/pages/sales-management/Management.vue"),
          children: [
            {
              path: "sales",
              name: "sales",
              component: () =>
                import("@/view/pages/sales-management/sales/List.vue"),
            },
            {
              path: "tambah",
              name: "tambah-sales",
              component: () =>
                import("@/view/pages/sales-management/sales/Form.vue"),
            },
            {
              path: "edit/:id",
              name: "edit-sales",
              component: () =>
                import("@/view/pages/sales-management/sales/Form.vue"),
            },
            {
              path: "lihat/:id",
              name: "lihat-sales",
              component: () =>
                import("@/view/pages/sales-management/sales/Form.vue"),
            },
            {
              path: "payment-method",
              name: "payment-method",
              component: () =>
                import("@/view/pages/sales-management/payment-method/List.vue"),
            },
            {
              path: "bank",
              name: "bank",
              component: () =>
                import("@/view/pages/sales-management/bank/List.vue"),
            },
          ],
        },
         {
          path: "/admin/stock-merchandise",
          name: "stock-merchandise",
          component: () =>
            import("@/view/pages/stock-merchandise/Management.vue"),
          children: [
            {
              path: "merchandise",
              name: "merchandise",
              component: () =>
                import("@/view/pages/stock-merchandise/merchandise/List.vue"),
            },
            {
              path: "merchandise-in-log",
              name: "merchandise-in-log",
              component: () =>
                import("@/view/pages/stock-merchandise/merchandise-in-log/List.vue"),
            },
            {
              path: "merchandise-out-log",
              name: "merchandise-out-log",
              component: () =>
                import("@/view/pages/stock-merchandise/merchandise-out-log/List.vue"),
            },
          ],
        },
        {
          path: "/admin/apps-management",
          name: "apps-management",
          component: () =>
            import("@/view/pages/apps-management/Management.vue"),
          children: [
            {
              path: "announcement",
              name: "announcement",
              component: () =>
                import("@/view/pages/apps-management/announcement/List.vue"),
            },
          ],
        },
        {
          path: "/admin/commission-management",
          name: "commission-management",
          component: () =>
            import("@/view/pages/apps-management/Management.vue"),
          children: [
            {
              path: "commission-config",
              name: "commission-config",
              component: () =>
                import(
                  "@/view/pages/sales-management/commission-config/List.vue"
                ),
            },
            {
              path: "commission-summary",
              name: "commission-summary",
              component: () =>
                import(
                  "@/view/pages/sales-management/commission-summary/List.vue"
                ),
            },
          ],
        },
        {
          path: "/admin/user-management",
          name: "user-management",
          component: () =>
            import("@/view/pages/user-management/UserManagement.vue"),
          children: [
            {
              path: "user",
              name: "user",
              component: () =>
                import("@/view/pages/user-management/user/ListUser.vue"),
            },
            {
              path: "zone",
              name: "zone",
              component: () =>
                import("@/view/pages/user-management/zone/ListZone.vue"),
            },
            {
              path: "role",
              name: "role",
              component: () =>
                import("@/view/pages/user-management/role/ListRole.vue"),
            },
            {
              path: "module",
              name: "module",
              component: () =>
                import("@/view/pages/user-management/module/ListModule.vue"),
            },
            {
              path: "action",
              name: "action",
              component: () =>
                import("@/view/pages/user-management/action/ListAction.vue"),
            },
          ],
        },
        {
          path: "/admin/files",
          name: "Files",
          component: () => import("@/view/pages/files/Files.vue"),
          children: [
            {
              path: "file",
              name: "file",
              component: () => import("@/view/pages/files/file/ListFile.vue"),
            },
            {
              path: "file-category",
              name: "file-category",
              component: () =>
                import("@/view/pages/files/file-category/ListFileCategory.vue"),
            },
          ],
        },
        {
          name: "/admin/scanner",
          path: "/admin/scanner",
          component: () => import("@/view/pages/auth/Scanner"),
          meta: {
            layout: "blank",
          },
        },
      ],
    },

    {
      path: "/error",
      name: "error",
      component: () => import("@/view/pages/error/Error.vue"),
      children: [
        {
          path: "error-1",
          name: "error-1",
          component: () => import("@/view/pages/error/Error-1.vue"),
        },
      ],
    },
    {
      path: "/admin",
      component: () => import("@/view/pages/auth/Auth"),
      children: [
        {
          name: "login",
          path: "/admin/login",
          component: () => import("@/view/pages/auth/Login"),
        },
        {
          name: "reset-password",
          path: "/admin/reset-password",
          component: () => import("@/view/pages/auth/ResetPassword"),
        },
        {
          name: "forgot-password",
          path: "/admin/forgot-password",
          component: () => import("@/view/pages/auth/ForgotPassword"),
        },
        // {
        //   name: "register",
        //   path: "/admin/register",
        //   component: () => import("@/view/pages/auth/Register"),
        // },
      ],
    },
    {
      path: "/password",
      name: "password",
      component: () => import("@/view/pages/auth/Auth"),
      children: [
        {
          name: "forgot-password",
          path: "/password/forgot",
          component: () => import("@/view/pages/auth/ForgotPassword"),
        },
      ],
    },
    {
      path: "*",
      redirect: "/404",
    },
    {
      // the 404 route, when none of the above matches
      path: "/404",
      name: "404",
      component: () => import("@/view/pages/error/Error-1.vue"),
    },
  ],
});
